import React from 'react';
import PropTypes from 'prop-types';
import './style';

const ProgressBar = (props) => {
  const { steps, value, className, width, ...attr } = props;

  const getWidth = (step) => {
    const stepWidth = 100 / steps;

    if (value >= (stepWidth * step)) return '100%';

    if ((value < (stepWidth * step)) && (value > (stepWidth * (step - 1)))) {
      const val = value - (stepWidth * (step - 1));

      return `${(val / stepWidth) * 100}%`;
    }

    return `0%`;
  };

  return (
    <div
      className={`progress-bar-wrapper flex gap-2 ${className}`}
      {...(width && { style: { width } })}
      {...attr}
    >
      {new Array(steps).fill(0).map((_, index) => (
        <div
          className="progress-bar-container"
          key={index}
        >
          <div
            className="progress-bar h-full bg-primary"
            style={{
              width: getWidth(index + 1),
              transition: `.5s linear width`,
            }}
          />
        </div>
      ))}
    </div>
  );
};

ProgressBar.propTypes = {
  steps: PropTypes.number,
  value: PropTypes.number,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

ProgressBar.defaultProps = {
  steps: 1,
  value: 0,
  className: '',
  width: '100%',
};

export default ProgressBar;
